import { bet, checkOnHoldBetStatus } from "../../js/api/betting.js";
import { getCurrentBalance } from "../../js/api/balance.js";
import { mybet, repeatbetinfo } from "../../js/api/myBet.js";
import {
  getGamePrintDetails,
  getGamePrintDetailsWithModal,
} from "../templates/print.js";
import { getUsers } from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
import { setCurrentBalance } from "../../js/app.js";
import {
  BETSLIP_AUTOPRINT_DESKTOP,
  BETSLIP_AUTOPRINT_MOBILE,
} from "../../js/constants/global-variables.js";

let playedValue = 0;
var betslipInterval = null;
let Betslip = {
  render: async () => {
    let betItem = "";

    (JSON.parse(localStorage.getItem("addObject")) || []).forEach((item, i) => {
      betItem =
        betItem +
        `<div class="betSlipSingleItem" game-id="${item.gameId}" bet-id="${
          item.coefId
        }">
               <div class="removeBetBtn">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>
               </div>
               <div class="betSlipSingleContent">
                 <div class="betSlipSingleDetails">
                   
                   <span class="betSlipSingleMatch">${item.getHomeName} - ${item.getAwayName}</span>
                   <span class="betSlipSingleType">${_t(item.matchMarket)} ${item.marketOption ? `( ${_t(item.marketOption)} )` : ""}</span>
                   <div class="betSlipSingleOdd ${item.coefId}-bs">
                   ${
                     item.oldCoefVal
                       ? `<span style=" text-decoration: line-through;">${(
                           Math.floor(
                             (parseFloat(item.oldCoefVal) + Number.EPSILON) *
                               100,
                           ) / 100
                         ).toFixed(2)}</span><span style="color:${
                           (
                             Math.floor(parseFloat(item.coefVal) * 100) / 100
                           ).toFixed(2) >
                           (
                             Math.floor(parseFloat(item.oldCoefVal) * 100) / 100
                           ).toFixed(2)
                             ? "green"
                             : "red"
                         }">${(
                           Math.floor(
                             (parseFloat(item.coefVal) + Number.EPSILON) * 100,
                           ) / 100
                         ).toFixed(2)}</span>`
                       : `<span> ${
                           Math.floor(
                             (parseFloat(item.coefVal) + Number.EPSILON) * 100,
                           ) / 100
                         }</span>`
                   }
                   
                 </div>
                 </div>
                 

             
               </div>
             </div>`;
    });

    let role = localStorage.getItem("role");
    let view = /*html*/ `
          <div class="betSlip" id="mainBetslip">
           <div class="betSlipHeader">
             <div class="betCount">
               <span>${
                 (JSON.parse(localStorage.getItem("addObject")) || []).length
               }</span>

             </div>
             <div class="betHeaderTitle">
               <span>${localStorage.getItem("role") == "Agent" ? `` : _t("Skedina")}</span>
               ${
                 localStorage.getItem("role") == "Agent"
                   ? `
               <select name="userSelect" class="userSelect" id="userSelect">
                 <option value="">${_t("Zgjidh nje")}</option>
                   ${await renderChildUsers()}
               </select>
                `
                   : ""
               }

                <select class="currencyValue" name="currencyValue" ${role === "Agent" || role === "User" ? 'style="display: none"' : ""}>
                  <option value="1" selected>Euro</a>
                  <option value="2">Lek</a>
                  <option value="3">Dollar</a>
                </select>
             </div>
             <div class="betHeaderCoef">
                <span id="betCoefCount"></span>
             </div>
             <div class="betBalance">
               <span><i>0.00</i></span>
             </div>
           </div>
           <div class="closeModal">
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>
              </div>
           <div class="betTypeWrapper multipleActive">

               <div class="multipleBtn">
                    <a class="singleBtn">${_t("Multiple")}</a>
                </div>
               <div class="systemBtn disabledBtn">
                    <select name="" id="systemBtn">
                    </select>
                </div>
                <div class="line-active"></div>
           </div>
           <div class="betSlipContent">
             ${betItem}
           </div>
           <div class="bsFooter">
            <div class="bsAmount">
              <input inputmode="decimal" name="placeBetAreaValue" id="placeBetAreaValue" placeholder="${_t("Shuma")}" />
              <label for="placeBetAreaValue">${_t("Shuma")}</label>
            </div>
            <div class="bsButton">
              <button id="betBtn" type="button" disabled>${_t("Vendos")}<span id="winningPrice"></span></button>
            </div>
           </div>
           <div class="betSlipFooter" style="display: none;">
             <div class="betStake">
               <span>${_t("Price")}</span>
               <i class="valueIcon"></i>
               <input type="text" inputmode="decimal" id="placeBetAreaValue_old" placeholder="Ps. 2.00">
             </div>
             <div class="betPlace">
               <span>${_t("Winning Chance:")}</span>
               <i class="valueIcon"></i>
               <span id="winningPrice">0.00</span>
             </div>
             <div class="currencyValue">
                <a class="currencySelector selected" currencyId="2">Lek</a>
                <a class="currencySelector" currencyId="1">Euro</a>
                <a class="currencySelector" currencyId="3">Dollar</a>
             </div> 
             <div class="betBtn" id="betBtn">
               <span id="btnDescription">${_t("Place Bet")}</span>
               <span class="valueIcon" id="valueIcon"></span>
               <span id="placeBetValue">0.00</span>
             </div>
           </div>
         </div>
        `;
    return view;
  },
  after_render: async () => {
    const username = localStorage.getItem("username") || "";

    $(".betSlipHeader .userSelect").unbind("change");
    $(".betSlipHeader .userSelect").on("change", function (e) {
      let currency = $("option:selected", this).attr("currency");
      if (!currency) return;

      currency = currency.split(",");

      const allCurrency = [
        { symbol: "€", id: "1", code: "EUR" },
        { symbol: "€", id: "1", code: "EURO" },
        { symbol: "L", id: "2", code: "LEK" },
        { symbol: "$", id: "3", code: "USD" },
        { symbol: "fr", id: "4", code: "CHF" },
        { symbol: "£", id: "5", code: "GBP" },
        { symbol: "д", id: "6", code: "MKD" },
      ].filter((i) => currency.some((c) => c === i.code));

      $(".betSlipHeader select.currencyValue").html("");
      $(".betSlipHeader select.currencyValue").append(
        allCurrency.map(
          (c, i) => `
        <option value="${c.id}" ${i === 0 ? "selected" : ""}>${c.code}</option>
      `,
        ),
      );
    });

    $("body").on("click", ".currencySelector", function (e) {
      $(e.currentTarget).parent().children().removeClass("selected");
      $(e.currentTarget).addClass("selected");
    });

    let currency = $("body").find(
      ".profileDetail .mmhdr-Header_InfoRow",
    ).length;
    if (currency > 1) {
      $("body #mainBetslip").addClass("currencySelector");
    } else {
      $("body #mainBetslip").removeClass("currencySelector");
    }

    let betslipDOM = document.getElementById("betslip");
    async function checkOnHoldBets() {
      let currency = $("body").find(
        ".profileDetail .mmhdr-Header_InfoRow",
      ).length;
      if (currency > 1) {
        $("body #mainBetslip").addClass("currencySelector");
      } else {
        $("body #mainBetslip").removeClass("currencySelector");
      }
      const onHoldBetId = localStorage.getItem("onHoldBetId");
      if (onHoldBetId && onHoldBetId != "0") {
        let dataToSend = {};

        if (localStorage.getItem("for-user")) {
          dataToSend["children_id"] = localStorage.getItem("for-user");
        }

        const result = await checkOnHoldBetStatus(onHoldBetId, dataToSend);

        if (result && result.bet_state_id && result.bet_state_id != 1) {
          if (result.bet_state_id == 3 && result.negotiated_values) {
            itemArray = JSON.parse(localStorage.getItem("onHoldBet"));
            $("body #messageModal").removeClass("showMessage");
            $("body .bettingBtn").removeClass("betSlipAdded");

            const newCoeficients = result.negotiated_values.split(",");

            await newCoeficients.forEach(async (element) => {
              const newCoefId = element.split("|")[0];
              const newCoefOdd = element.split("|")[1];
              let itemArrayItem = itemArray.find((a) => a.coefId == newCoefId);
              itemArrayItem.oldCoefVal = itemArrayItem.coefVal;
              itemArrayItem.coefVal = newCoefOdd;
            });

            localStorage.setItem("addObject", JSON.stringify(itemArray));
            betslipDOM.innerHTML = await Betslip.render();
            $("body .loaderWrapper-bet").remove();
            $("#mainBetslip").addClass("slideDown");
            $("body").on("click", ".currencySelector", function (e) {
              $(e.currentTarget).parent().children().removeClass("selected");
              $(e.currentTarget).addClass("selected");
            });

            let currency = $("body").find(
              ".profileDetail .mmhdr-Header_InfoRow",
            ).length;
            if (currency > 1) {
              $("body #mainBetslip").addClass("currencySelector");
            } else {
              $("body #mainBetslip").removeClass("currencySelector");
            }
            $("body").addClass("betSlipOpened");
            $("#btnDescription").text("Prano ndryshimet");
            $("body #messageModal").removeClass("showMessage");
            $("body #negotiationModal").addClass("showMessage");
            setTimeout(async function () {
              $("body #negotiationModal").removeClass("showMessage");
            }, 2000);

            $("body #placeBetAreaValue").val(
              localStorage.getItem("betSlipLastValue"),
            );
            $("body #placeBetValue").text(
              localStorage.getItem("betSlipLastValue"),
            );
            calculatePrice(localStorage.getItem("betSlipLastValue"));

            $("body #betBtn").prop(
              "disabled",
              !$("body #placeBetAreaValue").val(),
            );

            if ($("body #placeBetAreaValue").val().includes(",")) {
              $("body #placeBetAreaValue").val(
                $("body #placeBetAreaValue").val().replace(",", "."),
              );
            }
            if ($("body #placeBetAreaValue").value == 0) {
              $("body #placeBetValue").text("0");
              calculatePrice(0);
            } else {
              $("body #placeBetValue").text($("body #placeBetAreaValue").val());
              calculatePrice($("body #placeBetAreaValue").val());
            }

            $("body #mainBetslip").attr("items-length", itemArray.length);
          } else if (result.bet_state_id == 2) {
            // alert("Bileta u pranua");
            $("body #confirmationModal").addClass("showMessage");
            setTimeout(async function () {
              $("body #confirmationModal").removeClass("showMessage");
              $("body #messageModal").removeClass("showMessage");
              $("body .bettingBtn").removeClass("betSlipAdded");
              itemArray = [];
              localStorage.setItem("addObject", JSON.stringify(itemArray));
              localStorage.removeItem("coefHasChanged");
              betslipDOM.innerHTML = await Betslip.render();
              // $('.betSlipHeader').click();
              $(".betSlip > .closeModal").click();
            }, 2000);
            $("body .loaderWrapper-bet").remove();
            setCurrentBalance();

            const bet = await mybet(result.bet_id);

            const isMobile =
              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent,
              );
            if (window && !isMobile && BETSLIP_AUTOPRINT_DESKTOP) {
              // Print Desktop - Open print window
              const doc = getGamePrintDetails(bet);
              var printWin = window.open(
                "",
                "",
                "left=0,top=0,width=900,height=700,toolbar=0,scrollbars=0,status  =0",
              );
              if (printWin) {
                printWin.document.write(doc);
                printWin.document.close();
                printWin.focus();
                if (!mobileAndTabletCheck()) {
                  printWin.print();
                  printWin.onafterprint = function () {
                    printWin.close();
                  };
                } else {
                  //printWin.open();
                }
              }
            } else if (BETSLIP_AUTOPRINT_MOBILE) {
              // Print Mobile - Open modal with print details
              getGamePrintDetailsWithModal(bet);
            }
          } else {
            // alert("Bileta u refuzua: " + result.refused_message);
            $("body #refusedModal")
              .children()
              .children("p")
              .text(
                result.refused_message !== null && result.refused_message !== ""
                  ? result.refused_message
                  : _t("Bileta u refuzua!"),
              );
            $("body #refusedModal").addClass("showMessage");
            setTimeout(function () {
              $("body #messageModal").removeClass("showMessage");
              $("body .bettingBtn").removeClass("betSlipAdded");
              $("body #refusedModal").removeClass("showMessage");
            }, 2000);

            $("body .loaderWrapper-bet").remove();
            $("body .closeModal").click();
          }
          localStorage.removeItem("onHoldBet");
          localStorage.removeItem("onHoldBetId");
          localStorage.removeItem("for-user");
        }
      }
    }

    $("body").on("click", "#placeBetAreaValue", function () {
      $("body #placeBetAreaValue").keyup(function () {
        $("body #betBtn").prop("disabled", !$("body #placeBetAreaValue").val());

        if ($("body #placeBetAreaValue").val().includes(",")) {
          $("body #placeBetAreaValue").val(
            $("body #placeBetAreaValue").val().replace(",", "."),
          );
        }
        if ($("body #placeBetAreaValue").value == 0) {
          $("body #placeBetValue").text("0");
          calculatePrice(0);
        } else {
          $("body #placeBetValue").text($("body #placeBetAreaValue").val());
          calculatePrice($("body #placeBetAreaValue").val());
        }
      });
    });

    $("body").on("click", ".repeatTicket", async function (e) {
      let currency = $("body").find(
        ".profileDetail .mmhdr-Header_InfoRow",
      ).length;
      if (currency > 1) {
        $("body #mainBetslip").addClass("currencySelector");
      } else {
        $("body #mainBetslip").removeClass("currencySelector");
      }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const betId = $(e.currentTarget).attr("bet-id");
      const bet = await repeatbetinfo(betId);

      itemArray = [];

      for (let index = 0; index < bet.length; index++) {
        const element = bet[index];
        itemArray.push({
          coefId: element.coefId,
          coefVal: element.coefVal,
          gameId: element.gameId,
          gameName: element.gameName,
          getAwayName: element.getAwayName,
          getHomeName: element.getHomeName,
          matchMarket: ["1", "X", "2"].includes(element.matchMarket)
            ? "Rezultat final"
            : element.matchMarket,
          marketOption: element.matchMarket,
        });
      }

      localStorage.setItem("addObject", JSON.stringify(itemArray));
      betslipDOM.innerHTML = await Betslip.render();
    });

    let allowRequest = true;
    let betBtn = $("body #betBtn");

    if (betBtn) {
      $("body").on("click", "#betBtn", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        let placeBetAreaValue = 0;

        if (allowRequest) {
          allowRequest = false;
          $("body").addClass("requestHasBeenMade");

          $("body").on("click", ".currencySelector", function (e) {
            $(e.currentTarget).parent().children().removeClass("selected");
            $(e.currentTarget).addClass("selected");
          });

          let currency = $("body").find(
            ".profileDetail .mmhdr-Header_InfoRow",
          ).length;

          if (currency > 1) {
            $("body #mainBetslip").addClass("currencySelector");
          } else {
            $("body #mainBetslip").removeClass("currencySelector");
          }
          let coefHasChanged = localStorage.getItem("coefHasChanged");
          if (coefHasChanged) {
            $("#btnDescription").text("Place Bet");
            $("#valueIcon").text("");
            calculatePrice(0);
            localStorage.removeItem("coefHasChanged");
            allowRequest = true;
            return;
          }
          if (!localStorage.getItem("role")) {
            $("body .loginBtn").click();
          } else {
            if (
              $("body #placeBetAreaValue").val() == "" ||
              (JSON.parse(localStorage.getItem("addObject")) || []).length == 0
            ) {
              allowRequest = true;
              alert("please place a betting price or add any game on betslip");
            } else {
              $("body").append(
                '<div class="loaderWrapper-bet">\n' +
                  '            <div class="loader-bet"></div>\n' +
                  "        </div>",
              );

              const system = $("#systemBtn").val();
              placeBetAreaValue = $("body #placeBetAreaValue").val();
              let data = {
                total_sum: $("body #placeBetAreaValue").val(),
                cnk_value: system == "-1" ? "0" : system,
                bet_data: [],
              };

              (JSON.parse(localStorage.getItem("addObject")) || []).forEach(
                (item) => {
                  data.bet_data.push({
                    coeficient_id: item.coefId,
                    coeficient_value: item.coefVal,
                  });
                },
              );

              if ($("#userSelect").val()) {
                data["children_id"] = $("#userSelect").val();
                localStorage.setItem("for-user", $("#userSelect").val());
              }

              if ($("body #mainBetslip").hasClass("currencySelector")) {
                let currencyId = $("body #mainBetslip")
                  .find(".currencyValue option:selected")
                  .val();
                data.currency = currencyId;
              }

              localStorage.setItem(
                "betSlipLastValue",
                $("#placeBetAreaValue").val(),
              );

              const result = await bet(data);
              playedValue = data.total_sum;

              if (result.success) {
                //alert(result.message);

                $("body .loaderWrapper-bet").remove();
                if (result.success == "OK") {
                  allowRequest = true;
                  if (result.is_on_hold && result.is_on_hold == "1") {
                    allowRequest = false;
                    $("body").append(
                      '<div class="loaderWrapper-bet">\n' +
                        '            <div class="loader-bet"></div>\n' +
                        "        </div>",
                    );
                    localStorage.setItem(
                      "onHoldBet",
                      JSON.stringify(itemArray),
                    );
                    localStorage.setItem("onHoldBetId", result.on_hold_bet_id);
                  } else {
                    itemArray = [];
                    localStorage.setItem(
                      "addObject",
                      JSON.stringify(itemArray),
                    );
                    localStorage.removeItem("coefHasChanged");
                    betslipDOM.innerHTML = await Betslip.render();
                    // $('.betSlipHeader').click();
                    $(".betSlip > .closeModal").click();

                    const bet = await mybet(
                      result.on_hold_bet_id || result.bet_id,
                    );
                    const isMobile =
                      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                        navigator.userAgent,
                      );
                    if (window && !isMobile && BETSLIP_AUTOPRINT_DESKTOP) {
                      const doc = getGamePrintDetails(bet);
                      var printWin = window.open(
                        "",
                        "",
                        "left=0,top=0,width=900,height=700,toolbar=0,scrollbars=0,status  =0",
                      );
                      if (printWin) {
                        printWin.document.write(doc);
                        printWin.document.close();
                        printWin.focus();
                        if (!mobileAndTabletCheck()) {
                          printWin.print();
                          printWin.onafterprint = function () {
                            printWin.close();
                          };
                        } else {
                          //printWin.open();
                        }
                      } else {
                        $("body #ticketPrinting").addClass("showMessage");
                        $("body #ticketPrinting").html(doc);

                        setTimeout(function () {
                          $("body #ticketPrinting").removeClass("showMessage");
                        }, 7000);
                      }
                    } else if (BETSLIP_AUTOPRINT_MOBILE) {
                      // For mobile, open in iframe modal
                      getGamePrintDetailsWithModal(bet);
                    }
                  }
                }

                localStorage.setItem("addObject", JSON.stringify(itemArray));
                document.getElementById("winningPrice").innerHTML = "0";
                betslipDOM.innerHTML = await Betslip.render();
                $("body #mainBetslip").attr("items-length", itemArray.length);
                allowRequest = true;

                if (
                  !(result.changed_coefs && result.changed_coefs.length > 0)
                ) {
                  $("body .betSlip").addClass("slideDown");
                  $("body #messageModal").addClass("showMessage");
                  $("body #messageModal")
                    .children()
                    .children("p")
                    .text(_t(result.message));

                  if (result.message !== "Basti eshte ne pritje") {
                    setTimeout(function () {
                      $("body #messageModal").removeClass("showMessage");
                    }, 2000);
                  }
                }

                if (result.changed_coefs && result.changed_coefs.length > 0) {
                  for (
                    let index = 0;
                    index < result.changed_coefs.length;
                    index++
                  ) {
                    const changedCoef = result.changed_coefs[index];
                    var bs = document.getElementsByClassName(
                      changedCoef.coeficient_id + "-bs",
                    );
                    if (bs) {
                      for (let i = 0; i < bs.length; i++) {
                        let element = bs[i];
                        const oldPrice = element.getAttribute("match-odd")
                          ? element.getAttribute("match-odd")
                          : element.outerText;
                        if (
                          (
                            Math.floor(
                              parseFloat(changedCoef.coeficient_system_value) *
                                100,
                            ) / 100
                          ).toFixed(2) ==
                          (
                            Math.floor(parseFloat(oldPrice) * 100) / 100
                          ).toFixed(2)
                        )
                          continue;
                        let color =
                          (
                            Math.floor(
                              parseFloat(changedCoef.coeficient_system_value) *
                                100,
                            ) / 100
                          ).toFixed(2) >
                          (
                            Math.floor(parseFloat(oldPrice) * 100) / 100
                          ).toFixed(2)
                            ? "green"
                            : "red";

                        element.setAttribute(
                          "match-odd",
                          (
                            Math.floor(parseFloat(changedCoef.odd) * 100) / 100
                          ).toFixed(2),
                        );
                        element.innerHTML = `<span style=" text-decoration: line-through;">${(
                          Math.floor(
                            (parseFloat(oldPrice) + Number.EPSILON) * 100,
                          ) / 100
                        ).toFixed(2)}</span><span style="color:${color}">${(
                          Math.floor(
                            (parseFloat(changedCoef.coeficient_system_value) +
                              Number.EPSILON) *
                              100,
                          ) / 100
                        ).toFixed(2)}</span>`;
                      }
                    }

                    localStorage.setItem("coefHasChanged", coefHasChanged);
                    $("#btnDescription").text("Prano ndryshimet");
                    $("#valueIcon").text("");
                    $("#placeBetValue").text("");

                    updateCoefLocalStorage(
                      changedCoef.coeficient_id,
                      changedCoef.coeficient_system_value,
                    );
                    allowRequest = true;

                    $("body #placeBetAreaValue").val(placeBetAreaValue);

                    // Auto accept new coefs when changed
                    setTimeout(() => $("#btnDescription").click(), 200);
                  }
                }
                // setTimeout(function () {
                //   $("body #messageModal").removeClass("showMessage");
                // }, 2000);
                // $("body .bettingBtn ").removeClass("betSlipAdded");
              }
            }
          }

          if (localStorage.getItem("access_token")) {
            var currentBalanceResult = await getCurrentBalance();
            var coins = [];
            var allText = "";
            var mainBalance;
            const currencyItemTemplace = (currency, value) => {
              return `
              <div class="mmhdr-Header_InfoRow">
                <div class="mmhdr-Header_LeftSideWrapper">
                  <div class="mmhdr-UserInfo">
                    <div class="mmhdr-UserInfo_AccountInfo">
                      <div class="mmhdr-UserInfo_UserName">${username}</div>
                      <div class="mmhdr-UserInfo_AccountBalanceWrapper">
                        <div class="mmhdr-UserInfo_Balance">${parseFloat(value).toFixed(2)}</div>
                        <div class="mmhdr-UserInfo_CurrencyCode">${Utils.currencyCode(currency)}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              `;
            };

            if (currentBalanceResult && currentBalanceResult.total_coins) {
              var allCoins = currentBalanceResult.total_coins.split("|");

              if (currentBalanceResult.total_coins.includes("|")) {
                var allCoins = currentBalanceResult.total_coins.split("|");

                for (let index = 0; index < allCoins.length; index++) {
                  const coin = allCoins[index];
                  const currency = coin.split(";")[0].split(".")[1];
                  coins.push({
                    currency,
                    id: coin.split(";")[0].split(".")[0],
                  });

                  const value = coin.split(";")[1];
                  allText += currencyItemTemplace(currency, value);
                  if (mainBalance && mainBalance.value) {
                    if (parseFloat(mainBalance.value) < parseFloat(value))
                      mainBalance = { value, currency };
                  } else {
                    mainBalance = { value, currency };
                  }
                  // allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
                }
              } else {
                if (currentBalanceResult.currency) {
                  coins.push({
                    currency: currentBalanceResult.currency,
                    id: currentBalanceResult.currency_id,
                  });
                  // allText += `<b>${currentBalanceResult.currency} ${parseFloat(currentBalanceResult.total_coins).toFixed(2)} </b>`;

                  mainBalance = {
                    value: currentBalanceResult.total_coins,
                    currency: currentBalanceResult.currency,
                  };
                } else {
                  const currency = currentBalanceResult.total_coins
                    .split(";")[0]
                    .split(".")[1];
                  coins.push({
                    currency,
                    id: currentBalanceResult.total_coins
                      .split(";")[0]
                      .split(".")[0],
                  });

                  const value = currentBalanceResult.total_coins.split(";")[1];
                  // allText += currencyItemTemplace(currency, value);
                  mainBalance = { value, currency };
                  // allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
                }
              }

              if (mainBalance && mainBalance.value) {
                $("div[balance=username]").text(username);
                $("div[balance=value]").text(
                  Utils.formatNumber(mainBalance.value),
                );
                $("div[balance=currency]").text(
                  Utils.currencyCode(mainBalance.currency),
                );
                $("span.profileName.currentBalanceNew").html(
                  `${Utils.formatNumber(mainBalance.value)} ${Utils.currencyCode(mainBalance.currency)}`,
                );
              }
              $("#mmhdr-currency-wrapper").html(allText);
              // $('.currentBalanceNew').html(allText);

              localStorage.setItem("coins", JSON.stringify(coins));
            }
          }
        } else {
        }
      });
    }
    if ((JSON.parse(localStorage.getItem("addObject")) || []).length >= 3) {
      $("body .betTypeWrapper").addClass("systemAvailable");
      $(".betSlipSingleItem").each(function (i) {
        if (i === 1) {
          $("#systemBtn").append('<option value="-1">System</option>');
        }
        if (i >= 2) {
          $("#systemBtn").append(
            '<option value="' +
              i +
              '">' +
              i +
              "/" +
              (JSON.parse(localStorage.getItem("addObject")) || []).length +
              "</option>",
          );
        }
      });
    } else {
      $("body .betTypeWrapper").removeClass("systemAvailable");
    }
    if (betslipInterval) clearInterval(betslipInterval);
    betslipInterval = setInterval(checkOnHoldBets, 2000);
    if ((JSON.parse(localStorage.getItem("addObject")) || []).length == 0) {
      $("body .betSlip").addClass("hideMe");
    }

    $("body .betBalance i").text(
      $(".profileDetail .currentBalanceValue").text(),
    );
  },
};
var i = 0;
function getCombinations(input, size) {
  var results = [],
    result,
    mask,
    total = Math.pow(2, input.length);
  for (mask = 0; mask < total; mask++) {
    result = [];
    i = input.length - 1;
    do {
      if ((mask & (1 << i)) !== 0) {
        result.push(input[i]);
      }
    } while (i--);

    //ne qofte se duhen edhe bastet teke edhe vareja duhet ky rresht
    // if (result.length <= size && result.length > 0) {
    //perndryshe duhet ky
    if (result.length == size && result.length > 1) {
      results.push(result);
    }
  }
  //console.log(results);
  return results;
}

function treatCombinations(s) {
  var min = false;
  var max = [];
  var maxOdd = false;
  var arr = s;
  var l = arr.length;
  let value = 0;
  let element = document.getElementById("placeBetAreaValue");
  if (element && element.value) value = parseFloat(element.value) / l;

  var i = 0;
  for (; i < l; ) {
    (function (q) {
      var odd = value;
      for (var j in q) {
        odd = odd * q[j];
      }
      if (!min) {
        min = odd;
      } else if (odd < min) {
        min = odd;
      }
      if (!maxOdd) {
        maxOdd = odd;
      } else if (odd > maxOdd) {
        maxOdd = odd;
      }
      max.push(odd);
    })(arr[i]);
    i = i + 1;
  }

  let newMax = 0;
  for (let index = 0; index < max.length; index++) {
    const element = max[index];
    newMax += element;
  }

  return {
    min: min,
    max: max,
    maxOdd: maxOdd,
    combNo: l,
    newMax,
  };
}

function calculatePrice(value) {
  if (!value) {
    value = document.getElementById("placeBetAreaValue").value;
  }
  let totalValue = 1;

  itemArray.forEach((item) => {
    totalValue = totalValue * item.coefVal;
  });
  totalValue = totalValue * value;

  const size = $("#systemBtn").val();

  if (size && size !== "-1") {
    const odds = [];

    itemArray.forEach((element) => {
      odds.push(element.coefVal);
    });

    var s = getCombinations(odds, size);
    var r = treatCombinations(s);

    // $("#winningPrice")[0].innerHTML = `${Math.round(r.min * 100) / 100} / ${Math.round(r.newMax * 100) / 100
    //   }`;

    document.getElementById("winningPrice").textContent =
      _t("Fitimi") +
      ` ${Math.round(r.min * 100) / 100} / ${Math.round(r.newMax * 100) / 100}`;
  } else {
    // document.getElementById("winningPrice").textContent = parseFloat(
    //   totalValue
    // ).toFixed(2);
    document.getElementById("winningPrice").textContent =
      _t("Fitimi") + " " + Utils.formatNumber(totalValue);
  }
}
function mobileAndTabletCheck() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

async function renderChildUsers() {
  let users = await getUsers();
  let allUsers = users.data.children_users;
  let childrenUsers = [];

  if (allUsers && allUsers.length) {
    childrenUsers = allUsers.filter((value, index, self) => {
      return self.findIndex((v) => v.id === value.id) === index;
    });
  }

  let view = ``;

  for (let index = 0; index < childrenUsers.length; index++) {
    const element = childrenUsers[index];
    const currency = allUsers
      .filter((u) => u.id === element.id)
      .map((u) => u.currency)
      .join(",");
    view += `<option value="${element.id}" currency="${currency}"> 
        ${element.username}   
    </option>`;
  }

  return view;
}

export default Betslip;
